import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  header: {
    backgroundColor: "#14213d",
  },
  tab: {
    backgroundColor: "#14213d",
  },
  text: {
    color: "white",
  },
  tabText: {
    color: "#9fb0c9",
    fontWeight: "bold",
  },
  tabTextActive: {
    color: "white",
    fontWeight: "bold",
  },
  icon: {
    paddingLeft: 5,
  },
  body: {
    flex: 3,
  },
});

export default styles;
